<template>
  <el-dialog
    :visible="show"
    append-to-body
    width="500px"
    :title="id ? '修改热点' : '新增热点'"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <el-form ref="vForm" v-loading="loading" label-width="120px" :model="vForm">
      <el-form-item label="名称" prop="title" :rules="{ required: true, message: '名称必填' }">
        <el-input v-model="vForm.title"></el-input>
      </el-form-item>
      <el-form-item label="显示名称" prop="title">
        <el-switch v-model="vForm.isShowTitle" :active-value="1" :inactive-value="2"> </el-switch>
      </el-form-item>

      <el-form-item label="图标类型">
        <el-radio
          v-model="vForm.imageType"
          :label="1"
          :disabled="vForm.imageType == 3"
          @change="handleImageTypeChange"
        >
          动态图标
        </el-radio>
        <el-radio
          v-model="vForm.imageType"
          :label="2"
          :disabled="vForm.imageType == 3"
          @change="handleImageTypeChange"
        >
          静态图标
        </el-radio>
        <el-radio
          v-model="vForm.imageType"
          :label="7"
          :disabled="vForm.imageType == 3"
          @change="handleImageTypeChange"
        >
          图片查看
        </el-radio>
        <el-radio
          v-model="vForm.imageType"
          :label="4"
          :disabled="vForm.imageType == 3"
          @change="handleImageTypeChange"
        >
          文字图标
        </el-radio>
        <el-radio
          v-model="vForm.imageType"
          :label="5"
          :disabled="vForm.imageType == 3"
          @change="handleImageTypeChange"
        >
          地点标注图标
        </el-radio>
        <el-radio
          v-model="vForm.imageType"
          :label="6"
          :disabled="vForm.imageType == 3"
          @change="handleImageTypeChange"
        >
          人物介绍
        </el-radio>
        <el-radio
          v-model="vForm.imageType"
          :label="3"
          :disabled="vForm.imageType != 3"
          @change="handleImageTypeChange"
        >
          地板热点
        </el-radio>
      </el-form-item>

      <el-form-item
        v-if="vForm.imageType != 4 && vForm.imageType != 5"
        label="图标"
        prop="image"
        :rules="{ required: true, message: '图标必填' }"
      >
        <u-image v-model="image" width="100" height="100" @change="onSelectImage" />
        <div v-if="vForm.imageType != 3 && vForm.imageType != 6" class="default-box">
          <div>快捷选项：</div>
          <div v-if="vForm.imageType == 1" class="default-img-list">
            <img
              v-for="item in defaultImageDynamic"
              :key="item.key"
              class="default-img"
              :src="item.thumb"
              @click="setDefaultImage(item)"
            />
          </div>
          <div v-if="vForm.imageType == 2" class="default-img-list">
            <img
              v-for="item in defaultImageStatic"
              :key="item.key"
              class="default-img"
              :src="item.thumb"
              @click="setDefaultImage(item)"
            />
          </div>
        </div>
      </el-form-item>

      <template v-if="vForm.imageType == 4">
        <el-form-item
          label="文字图标颜色"
          prop="ext.iconTxtColor"
          :rules="{ required: true, message: '图标文字颜色必填' }"
        >
          <el-color-picker v-model="vForm.ext.iconTxtColor"></el-color-picker>
        </el-form-item>
        <el-form-item
          label="文字图标背景"
          prop="ext.iconTxtBgColor"
          :rules="{ required: true, message: '图标背景颜色必填' }"
        >
          <el-color-picker show-alpha v-model="vForm.ext.iconTxtBgColor"></el-color-picker>
        </el-form-item>

        <el-form-item
          label="文字图标圆角"
          prop="ext.iconTxtRadius"
          :rules="{ required: true, message: '图标圆角必填' }"
        >
          <el-input v-model="vForm.ext.iconTxtRadius">
            <template slot="append">px</template>
          </el-input>
        </el-form-item>
        <el-form-item
          label="文字图标内边距"
          prop="ext.iconTxtPadding"
          :rules="{ required: true, message: '文字图标内边距必填' }"
        >
          <el-input v-model="vForm.ext.iconTxtPadding">
            <template slot="append">px</template>
          </el-input>
        </el-form-item>
      </template>

      <template v-if="vForm.imageType == 5">
        <el-form-item
          label="图标"
          prop="ext.iconTxtColor"
          :rules="{ required: true, message: '图标文字颜色必填' }"
        >
          <img src="../../../assets/images/position.png" style="display: block;width: 40px;" />
        </el-form-item>
        <el-form-item label="详细说明">
          <el-input v-model="vForm.ext.positionDesc"></el-input>
          <div class="v-form-tips">详细说明会在点击图标时显示</div>
        </el-form-item>
      </template>

      <template v-if="vForm.imageType != 4 && vForm.imageType != 5">
        <el-form-item class="form-item-multiple" label="缩放倍数">
          <el-form-item prop="scale" :rules="{ required: true, message: '电脑缩放必填' }">
            <el-input v-model="vForm.scale" type="number">
              <template slot="prepend">电脑</template>
            </el-input>
            <div class="v-form-tips">0-1为缩小倍数，>1为放大倍数</div>
          </el-form-item>
          <el-form-item prop="mScale" :rules="{ required: true, message: '手机缩放必填' }">
            <el-input v-model="vForm.mScale" type="number">
              <template slot="prepend">手机</template>
            </el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item
          label="图标透明度"
          prop="opacity"
          :rules="{ required: true, message: '图标透明度必填' }"
        >
          <el-input v-model="vForm.opacity" type="number"></el-input>
          <div class="v-form-tips">透明度范围0-1</div>
        </el-form-item>
        <el-form-item
          v-if="vForm.imageType != 4"
          class="form-item-multiple"
          required
          label="图标宽高"
        >
          <el-form-item prop="width" :rules="{ required: true, message: '宽度必填' }">
            <el-input v-model="vForm.width">
              <template slot="prepend">宽度</template>
              <span slot="append">px</span>
            </el-input>
            <div class="v-form-tips">动态图中宽高为每一帧图像宽高</div>
          </el-form-item>
          <el-form-item prop="height" :rules="{ required: true, message: '高度必填' }">
            <el-input v-model="vForm.height">
              <template slot="prepend">高度</template>
              <span slot="append">px</span>
            </el-input>
          </el-form-item>
        </el-form-item>
      </template>

      <el-form-item
        v-if="vForm.imageType != 3"
        class="form-item-multiple"
        label="字体大小"
        :rules="{ required: true }"
      >
        <el-form-item prop="fontSize" :rules="{ required: true, message: '电脑字体大小必填' }">
          <el-input v-model="vForm.fontSize" type="number">
            <template slot="prepend">电脑</template>
            <template slot="append">px</template>
          </el-input>
          <div class="v-form-tips">字体最小12px</div>
        </el-form-item>
        <el-form-item prop="mFontSize" :rules="{ required: true, message: '手机字体大小必填' }">
          <el-input v-model="vForm.mFontSize" type="number">
            <template slot="prepend">手机</template>
            <template slot="append">px</template>
          </el-input>
        </el-form-item>
      </el-form-item>

      <template v-if="vForm.imageType != 5 && vForm.imageType != 6 && vForm.imageType != 7">
        <el-form-item label="打开类型">
          <el-radio v-model="vForm.type" :label="1">VR</el-radio>
          <el-radio v-model="vForm.type" :label="2">视频</el-radio>
          <el-radio v-model="vForm.type" :label="3">文字介绍</el-radio>
        </el-form-item>

        <el-form-item v-if="vForm.type == 1" label="VR链接">
          <div class="url-select">
            <div style="flex:1;">
              <el-input
                v-if="vForm.vrType == 1"
                v-model="vForm.url"
                class="url-select-in"
                clearable
                @change="vForm.fromId = ''"
              ></el-input>
              <el-select
                v-if="vForm.vrType == 2"
                v-model="vForm.fromId"
                style="width:100%"
                placeholder="作品内选择"
                @change="vForm.url = ''"
              >
                <el-option
                  v-for="item in sceneList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <el-button
              class="url-select-btn"
              type="info"
              @click="vForm.vrType = vForm.vrType == 1 ? 2 : 1"
            >
              {{ vForm.vrType == 1 ? '作品内选择' : '输入链接' }}
            </el-button>
          </div>
          <div class="v-form-tips">必须是https协议链接，即以https开头的链接</div>
        </el-form-item>

        <el-form-item v-if="vForm.type == 2" label="视频链接">
          <div class="url-select">
            <div v-if="vForm.videoType == 1" class="video-control">
              <el-input
                v-model="vForm.url"
                class="url-select-in"
                clearable
                :readonly="videoPercent > 0"
                @input="
                  video = {};
                  vForm.video = '';
                  vForm.videoPreview = '';
                "
              ></el-input>
              <el-progress
                v-if="videoPercent > 0"
                class="video-progress"
                :text-inside="true"
                :stroke-width="40"
                :percentage="videoPercent"
                status="success"
              ></el-progress>
            </div>
            <el-button
              v-if="vForm.videoType == 1"
              class="url-select-btn"
              type="info"
              :loading="videoPercent > 0"
            >
              手动上传
            </el-button>
            <u-video
              v-model="video"
              :class="{ 'select-video-btn': vForm.videoType == 1 }"
              width="150"
              height="150"
              @change="onSelectVideo"
              @progress="(e) => (videoPercent = e)"
            />
          </div>
          <div class="v-form-tips">必须是https协议链接，即以https开头的链接</div>
        </el-form-item>

        <el-form-item v-if="vForm.type == 3" label="文字介绍">
          <div style="line-height:14px">
            <vue-ueditor-wrap v-model="vForm.ext.spotTextIntro" :config="editorConfig" />
          </div>
        </el-form-item>
      </template>

      <template v-if="vForm.imageType == 6">
        <el-form-item label="人物名称">
          <el-input v-model="vForm.ext.introName" type="text"></el-input>
        </el-form-item>
        <el-form-item label="人物标签">
          <el-input v-model="vForm.ext.introLabel" type="text"></el-input>
          <div class="v-form-tips">显示在人物名称左侧</div>
        </el-form-item>
        <el-form-item label="详情内容">
          <div style="line-height:14px">
            <vue-ueditor-wrap v-model="vForm.ext.introText" :config="editorConfig" />
          </div>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        v-if="id && vForm.imageType == 3"
        type="danger"
        size="small"
        @click="deleteHotSpot(id)"
      >
        删除此热点
      </el-button>
      <el-button size="small" @click="closeDialog">关闭</el-button>
      <el-button type="primary" size="small" :loading="doSubmitLoading" @click="doSubmit">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import defaultSpot from '../data/data-default-spot';
import build from '../build';
import VueUeditorWrap from 'vue-ueditor-wrap';

export default {
  components: { VueUeditorWrap },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
    row: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      loading: false,
      doSubmitLoading: false,
      vForm: {
        id: '',
        materialId: '',
        title: '',
        ath: 0,
        atv: 0,
        width: 30,
        height: 30,
        image: '',
        imagePreview: '',
        video: '',
        videoPreview: '',
        imageType: 1, //图标类型 1动态 2静态
        type: 1, //热点类型 1打开VR  2打开视频
        url: '',
        videoType: 1, //视频类型  1链接  2手动上传
        scale: 0.4,
        mScale: 0.3,
        vrType: 2, //打开VR类型  1链接 2关联id
        fromName: '',
        fromId: '',
        opacity: 1,
        fontSize: 16,
        mFontSize: 12,
        isShowTitle: 1,
        ext: {
          tx: 0,
          ty: 0,
          tz: 0,
          rx: 0,
          distorted: false,
          depth: 1000,
          rotationorder: 'xyz',
          bgcolor: '',
          iconTxtColor: '#fff',
          iconTxtBgColor: '#ff0000',
          iconTxtRadius: 4,
          iconTxtPadding: 4,
          positionDesc: '', //位置图标详细说明
          introLabel: '',
          introName: '',
          introText: '',
          spotTextIntro: '', //文字介绍
        },
      },
      image: {},
      video: {},
      defaultImageDynamic: defaultSpot.dynamic,
      defaultImageStatic: defaultSpot.static,
      videoPercent: 0,
      editorConfig: {
        //ueditor编辑器配置
        UEDITOR_HOME_URL: '/UEditor/',
        autoHeightEnabled: false,
        initialFrameHeight: 300,
        initialFrameWidth: 340,
      },
    };
  },

  computed: {
    ...mapState('tour', ['krp', 'materialId', 'workDetail']),
    sceneList() {
      return Array.isArray(this.workDetail.sceneList)
        ? this.workDetail.sceneList.filter((item) => item.id != this.materialId)
        : [];
    },
  },

  watch: {
    videoPercent(val) {
      if (val == 100) {
        this.videoPercent = 0;
      }
    },
  },

  created() {
    this.vForm.materialId = this.materialId;
    if (this.row) {
      for (let key in this.row) {
        if (Object.prototype.toString.call(this.row[key]) === '[object Object]') {
          for (let key2 in this.row[key]) {
            this.vForm[key][key2] = this.row[key][key2];
          }
        } else {
          this.vForm[key] = this.row[key];
        }
      }
      if (this.row.image) {
        this.image = { key: this.row.image, preview: this.row.imagePreview };
      }
    }
    if (this.id) {
      this.getDetail();
    }
    if (!this.id && this.vForm.imageType != 3) {
      this.vForm.ath = this.krp.get('view.hlookat');
      this.vForm.atv = this.krp.get('view.vlookat');
    }
  },

  methods: {
    ...mapActions('tour', {
      actionGetSceneDetail: 'getSceneDetail',
    }),

    //关闭弹窗
    closeDialog() {
      this.$emit('update:show', false);
    },

    async getDetail() {
      this.loading = true;
      try {
        let res = await this.api.spot.getSpotInfo({ id: this.id });
        for (let key in this.vForm) {
          this.vForm[key] = res.data[key];
        }
        let indexDefaultImage = this.defaultImageDynamic.find((item) => item.key == res.data.image);
        this.image = res.data.image
          ? {
              key: res.data.image,
              preview: indexDefaultImage ? indexDefaultImage.thumb : res.data.imagePreview,
            }
          : {};
        this.video = res.data.video ? { key: res.data.video, preview: res.data.videoPreview } : {};
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    onSelectImage() {
      let indexDefaultImage = this.defaultImageDynamic.find((item) => item.key == this.image.key);
      this.vForm.image = this.image.key;
      this.vForm.imagePreview = indexDefaultImage ? indexDefaultImage.preview : this.image.preview;
      this.$refs.vForm.validateField('image');
    },

    //监听上传视频
    onSelectVideo() {
      this.vForm.video = this.video.key;
      this.vForm.videoPreview = this.video.preview;
      this.vForm.url = '';
      this.vForm.videoType = this.video.key ? 2 : 1;
    },

    onVideoProgress(percent) {
      this.videoPercent;
      console.log(percent);
    },

    //设置默认图标
    setDefaultImage(row) {
      this.image = { key: row.key, preview: row.thumb || row.preview };
      this.vForm.width = row.width;
      this.vForm.height = row.height;
      this.vForm.scale = row.scale;
      this.onSelectImage();
    },

    //监听上传图片
    handleImageTypeChange() {
      this.image = {};
      this.vForm.image = '';
      this.vForm.imagePreview = '';
    },

    //删除热点
    async deleteHotSpot(id) {
      try {
        await this.$confirm('确认删除?', '提示', { type: 'warning' });
        this.doDeleteHotSpot(id);
      } catch (e) {
        console.error(e);
      }
    },

    async doDeleteHotSpot(id) {
      try {
        await this.api.spot.delete({ id });
        let name = `hotspot_${id}`;
        build.removeHotspots(this.krp, [
          name,
          name + '_placeholder',
          name + '_edit',
          name + '_delete',
          name + '_title',
          name + '_desc',
        ]);
        this.$message.success('删除成功');
        this.actionGetSceneDetail({ materialId: this.materialId });
        this.closeDialog();
      } catch (e) {
        console.error(e);
      }
    },

    //确认添加热点图标
    async doSubmit() {
      this.doSubmitLoading = true;
      try {
        await this.$refs.vForm.validate();
        if (this.vForm.imageType == 5) {
          this.vForm.image = 'c72ba3b4_16ba_48c2_9cf5_5543c7baa8701653364114413';
          this.vForm.imagePreview =
            'https://vybbasevr.vyb.cn/c72ba3b4_16ba_48c2_9cf5_5543c7baa8701653364114413';
          this.vForm.width = 36;
          this.vForm.height = 48;
          this.vForm.scale = 0.5;
          this.vForm.mScale = 0.5;
        }
        let res = await this.api.spot[this.id ? 'edit' : 'add'](this.vForm);
        this.vForm.id = this.vForm.id || res.data.id;
        if (this.id) {
          let name = `hotspot_${this.id}`;
          build.removeHotspots(this.krp, [
            name,
            name + '_placeholder',
            name + '_edit',
            name + '_delete',
            name + '_title',
            name + '_desc',
          ]);
        }
        this.renderHotspot(this.vForm);
        this.actionGetSceneDetail({ materialId: this.materialId });
        this.$message.success(`${this.id ? '修改' : '添加'}成功`);
        this.closeDialog();
      } catch (e) {
        console.error(e);
      }
      this.doSubmitLoading = false;
    },

    renderHotspot(data) {
      data.isMobile = this.isMobile;
      if (
        data.imageType == 1 ||
        data.imageType == 2 ||
        data.imageType == 6 ||
        data.imageType == 7
      ) {
        build.rednerHotspot(this.krp, data);
        build.renderHotspotPlaceholder(this.krp, data);
        build.renderHotspotEdit(this.krp, data);
        build.renderHotspotDelete(this.krp, data);
        if (data.isShowTitle === 1) {
          build.renderHotspotTitle(this.krp, data);
        }
      }
      if (data.imageType == 3) {
        build.rednerHotspot(this.krp, data);
      }
      if (data.imageType == 4) {
        build.rednerHotspotText(this.krp, data);
        build.renderHotspotEdit(this.krp, data);
        build.renderHotspotDelete(this.krp, data);
      }
      if (data.imageType == 5) {
        build.rednerHotspot(this.krp, data);
        build.renderHotspotPlaceholder(this.krp, data);
        build.renderHotspotEdit(this.krp, data);
        build.renderHotspotDelete(this.krp, data);
        if (data.isShowTitle === 1) {
          build.renderHotspotTitle(this.krp, data);
        }
        build.renderHotspotDesc(this.krp, data);
      }
    },
  },
};
</script>

<style scoped>
.default-box {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-top: 10px;
}

.default-img-list {
  display: flex;
  align-items: center;
}

.default-img {
  display: block;
  width: 30px;
  height: 30px;
  background: #ccc;
  margin-left: 5px;
  cursor: pointer;
}

.select-vr {
  position: relative;
}

.select-vr-control {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.form-item-multiple > .el-form-item__content {
  display: flex;
  align-items: flex-start;
}

.form-item-multiple > .el-form-item__content .el-form-item {
  flex: 1;
}

.form-item-multiple > .el-form-item__content .el-form-item:first-child {
  margin-right: 3px;
}

.form-item-multiple > .el-form-item__content .el-form-item:last-child {
  margin-left: 3px;
}

.url-select {
  position: relative;
  display: flex;
  align-items: center;
}

.url-select-clear {
  position: absolute;
  top: 0;
  right: 100px;
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
}

.url-select-in >>> .el-input__inner {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.url-select-btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.select-video-btn {
  position: absolute;
  height: 40px;
  width: 100px;
  right: 0;
  top: 0;
  overflow: hidden;
  opacity: 0;
}

.video-control {
  flex: 1;
  position: relative;
}

.video-progress {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
</style>
